module.exports = __webpack_public_path__ + "img/0D0DE3_040486_0404AF_0404CF-256px.16bdd89a.png";